import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

export enum ValidPointsDropdownOptions {
  showValidPoints = 'showValidPoints',
  showInvalidPoints = 'showInvalidPoints',
  showAllPoints = 'showAllPoints',
}

interface ScanDataState {
  showValidPointsDropdown: ValidPointsDropdownOptions;
  lastScanDataUpdateTimestamp: number;
}

const initialState: ScanDataState = {
  showValidPointsDropdown: ValidPointsDropdownOptions.showValidPoints,
  lastScanDataUpdateTimestamp: Date.now(),
};

export const scanDataState = createSlice({
  name: 'scanData',
  initialState,
  reducers: {
    initScanData: () => initialState,
    setShowValidPointsDropdown: (
      state,
      action: PayloadAction<ValidPointsDropdownOptions>
    ) => {
      state.showValidPointsDropdown = action.payload;
    },
    setLastScanDataUpdateTimestamp: (state, action: PayloadAction<number>) => {
      state.lastScanDataUpdateTimestamp = action.payload;
    },
  },
});

export const {
  initScanData,
  setShowValidPointsDropdown,
  setLastScanDataUpdateTimestamp,
} = scanDataState.actions;

export const selectShowValidPointsDropdown = (state: RootState) =>
  state.scanData.showValidPointsDropdown;
export const selectLastScanDataUpdateTimestamp = (state: RootState) =>
  state.scanData.lastScanDataUpdateTimestamp;

export const selectAllScanDataState = (state: RootState) => state.scanData;

export default scanDataState.reducer;
